const BR_TIMEZONE = "America/Sao_Paulo";

// Converte um valor de <input type="datetime-local"> (sem fuso — interpretado
// pelo navegador no fuso da própria máquina do atendente) para a string
// "YYYY-MM-DDTHH:MM" equivalente no horário de Brasília. Protege o GLPI e o
// tempo de atividade calculado no backend contra atendentes com o
// relógio/fuso da máquina configurado fora de GMT-3.
export const toBrasiliaWallClock = (datetimeLocalValue) => {
	if (!datetimeLocalValue) return datetimeLocalValue;
	const instant = new Date(datetimeLocalValue);
	if (Number.isNaN(instant.getTime())) return datetimeLocalValue;
	const parts = new Intl.DateTimeFormat("en-CA", {
		timeZone: BR_TIMEZONE,
		year: "numeric", month: "2-digit", day: "2-digit",
		hour: "2-digit", minute: "2-digit", hourCycle: "h23"
	}).formatToParts(instant);
	const get = t => parts.find(p => p.type === t)?.value;
	return `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get("minute")}`;
};

// Converte um instante (Date, ou string ISO de um campo já resolvido pelo
// backend) para o valor "YYYY-MM-DDTHH:MM" equivalente no horário de
// Brasília — usado para pré-carregar um <input type="datetime-local">.
export const instantToBrasiliaInputValue = (date) => {
	if (!date) return "";
	const instant = date instanceof Date ? date : new Date(date);
	if (Number.isNaN(instant.getTime())) return "";
	const parts = new Intl.DateTimeFormat("en-CA", {
		timeZone: BR_TIMEZONE,
		year: "numeric", month: "2-digit", day: "2-digit",
		hour: "2-digit", minute: "2-digit", hourCycle: "h23"
	}).formatToParts(instant);
	const get = t => parts.find(p => p.type === t)?.value;
	return `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get("minute")}`;
};
